export abstract class ServiceBase {
  constructor(protected baseUrl: string) {}
}
